import { render, staticRenderFns } from "./details-modal.vue?vue&type=template&id=4adf572e&scoped=true&"
import script from "./details-modal.vue?vue&type=script&lang=ts&"
export * from "./details-modal.vue?vue&type=script&lang=ts&"
import style0 from "./details-modal.vue?vue&type=style&index=0&id=4adf572e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf572e",
  null
  
)

export default component.exports